// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateSimpleTextSetting_createButton__1j4RH"};